import { Component } from '@angular/core';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { StorageService } from '../../../core/storage/storageService';
import { Router } from '@angular/router';
import { UIHelpers } from '../../../core/ui-helpers';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { Options } from '../../ui/filterable-table/options';
import { Invoice } from '../../../models/invoices/invoice';
import { InvoiceService } from '../../../models/invoices/invoiceService';
import { SearchFilters } from '../../../models/search/searchFilters';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-invoice-table-view',
  templateUrl: './invoice-table-view.component.html',
  standalone: false,
})
export class InvoiceTableViewComponent extends TableViewAbstractComponent {
  canViewInvoices: boolean = false;
  canCreateInvoices: boolean = false;

  loading: boolean = true;

  IconType = IconType;

  today: Date = new Date();

  constructor(
    private storage: StorageService,
    private router: Router,
    private invoiceService: InvoiceService,
    public uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
    private access: AccessManager,
  ) {
    super();

    this.access
      .getUserAccess([
        AccessManager.AUTH_VIEW_INVOICES,
        AccessManager.AUTH_CREATE_INVOICES,
      ])
      .then((access) => {
        this.canViewInvoices = access[AccessManager.AUTH_VIEW_INVOICES];
        this.canCreateInvoices = access[AccessManager.AUTH_CREATE_INVOICES];
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  getRecordFromDataSource(invoiceId: string): Invoice {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == invoiceId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Invoice not found in dataset';
  }

  checkIfInvoicePastDue(invoice: Invoice): boolean {
    return this.uiHelpers.calculateDaysSince(this.today, invoice.dueDate) <= 0;
  }

  getPageOfData(
    query: string,
    filters: any[],
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
    options: Options,
  ): Promise<Page<Invoice>> {
    let merchantId = this.storage.getSelectedLocation()?.id ?? '';

    return this.invoiceService
      .getPaged(
        merchantId,
        query,
        pageNum,
        pageSize,
        sortColumn,
        sortDirection,
        options.invoiceStatus ?? '',
      )
      .then((results) => {
        this.loading = false;
        return results;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        this.loading = false;
        return new Page<Invoice>({});
      });
  }

  canQuery(): boolean {
    return true;
  }

  viewInvoice(invoiceId: string) {
    this.storage.setSelectedInvoiceId(invoiceId);
    this.router.navigate(['/merchant/invoices/create'], {
      queryParams: { viewInvoiceMode: 'true' },
    });
  }

  deleteInvoice(invoiceId: string) {
    if (confirm('Are you sure you want to delete this invoice?')) {
      this.invoiceService
        .deleteInvoice(invoiceId)
        .then(() => {
          this.reload('', new SearchFilters({}), 0, this._pageSize);
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }
}
